class PasswordDrop extends Theme.Component {
  static STORAGE_KEY = 'password-drop:authenticated';

  connectedCallback() {
    super.connectedCallback();

    this.defineElements({
      form: '[data-password-form]',
      input: '[data-password-input]',
      error: '[data-password-error]',
      unlock: '[data-unlock]'
    });

    this.elements.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submitPassword();
    });

    this.initCountdown();
    this.classList.add('password-drop--ready');
  }

  showForm() {
    this.elements.unlock.style.display = 'none';
    this.elements.form.classList.add('unlocked');
    this.elements.input.focus();
  }

  submitPassword() {
    const value = this.elements.input.value.trim();

    if (value === this.dataset.password) {
      sessionStorage.setItem(PasswordDrop.STORAGE_KEY, '1');
      this.classList.add('password-drop--exiting');
      this.addEventListener('transitionend', () => this.remove(), { once: true });
      setTimeout(() => this.remove(), 600);
    } else {
      this.elements.error.textContent = 'Incorrect password';
      this.elements.error.style.display = '';
      this.elements.input.value = '';
      this.elements.input.focus();
    }
  }

  initCountdown() {
    const countdown = this.querySelector('[data-countdown-target]');
    const target = countdown && countdown.dataset.countdownTarget;
    if (!target) return;

    const hour1 = this.querySelector('[data-hour-1]');
    const hour2 = this.querySelector('[data-hour-2]');
    const minute1 = this.querySelector('[data-minute-1]');
    const minute2 = this.querySelector('[data-minute-2]');

    if (!hour1) return;

    const update = () => {
      const remaining = new Date(target).getTime() - Date.now();

      if (remaining <= 0) {
        hour1.textContent = '0';
        hour2.textContent = '0';
        minute1.textContent = '0';
        minute2.textContent = '0';
        clearInterval(interval);
        return;
      }

      const totalMinutes = Math.ceil(remaining / 1000 / 60);
      const hours = Math.floor(totalMinutes / 60).toString().padStart(2, '0');
      const minutes = (totalMinutes % 60).toString().padStart(2, '0');

      hour1.textContent = hours[0];
      hour2.textContent = hours[1];
      minute1.textContent = minutes[0];
      minute2.textContent = minutes[1];
    };

    update();
    const interval = setInterval(update, 1000);
  }
}

customElements.define('password-drop', PasswordDrop);
